import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-five-second-test",
  "use": "foquz-icon-question-five-second-test-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" fill=\"none\" id=\"foquz-icon-question-five-second-test\"><path d=\"M7.5 7.5h.01\" stroke=\"#3F65F1\" stroke-width=\"3\" stroke-linecap=\"round\" /><path d=\"M18 12a5 5 0 100 10 5 5 0 000-10zm0 0V6a2 2 0 00-2-2H5a2 2 0 00-2 2v11a2 2 0 002 2h8m5-4v2h2m-4-5l-3-3-4 4-2-2-4 4\" stroke=\"#3F65F1\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol